import {webRequest, webNoTokenRequest} from '../api'

// 報表款項篩選
export function statementOption(data) {
    return webRequest({
        url:'/v1/oauth/management/financial/statementOption',
        method:'post',
        data: data,
    })
}

// 屋主報表
export function getLandlordReport() {
    return webRequest({
        url:'/v1/oauth/management/financial/landlordReport',
        method:'get',
    })
}
// 物件報表
export function getObjectReport(params) {
    return webRequest({
        url:'/v1/oauth/management/financial/objectReport',
        method:'get',
        params: params
    })
}
// 歷史報表 
export function getHistoryReport(data) {
    return webRequest({
        url:'/v1/oauth/management/financial/recordReport',
        method:'post',
        data: data,
    })
}
// 屋主月對帳單下載
export function getLandlordReportExcel(params) {
    return webRequest({
        url:'/v1/oauth/management/landlord/getLandlordMonthlyStatement',
        method:'get',
        responseType: 'blob',
        params: params
    })
}
// 更新對帳狀態 
export function updateReconcileStatus(data) {
    return webRequest({
        url:'/v1/oauth/management/financial/updateReconcileStatus',
        method:'post',
        data: data,
    })
}

// 產生對帳單 
export function computeStatement(data) {
    return webRequest({
        url:'/v1/oauth/management/financial/computeStatement',
        method:'post',
        data: data,
    })
}
// 刪除對帳單 
export function deteleStatement(data) {
    return webRequest({
        url:'/v1/oauth/management/financial/deteleStatement',
        method:'post',
        data: data,
    })
}
// 編輯報表頁面 params {statementId: String targetType: String}
export function editStatementPage(params) {
    return webRequest({
        url:'/v1/oauth/management/financial/editStatementPage',
        method:'get',
        params: params
    })
}


// WEBPACK FOOTER //
// ./src/apis/company/landlordReport.js